import { createFileRoute } from '@tanstack/react-router'
import { AvailabilityManagement } from '@/features/availability'
import { redirectBsohtakDoctor } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/availability')({
  beforeLoad: redirectBsohtakDoctor('/my-missions'),
  component: AvailabilityManagement,
})
